import { EventType } from 'matrix-js-sdk'

export const snippetViewableType: string[] = [EventType.RoomMessage, EventType.Sticker]
